import { Helmet } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import EmployeesTimelineTable from './EmployeesTimelineTable';

export default function EmployeesTimeline() {
  const queryClient = new QueryClient();

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Helmet>
          <title> Employees-TimeLine </title>
        </Helmet>
        <EmployeesTimelineTable />
      </QueryClientProvider>
    </>
  );
}
